/** Native scrolling preserves trackpad, touch and keyboard behavior. */
export function scrollToEdge(edge: "top" | "bottom") {
  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({
    top: edge === "top" ? 0 : document.documentElement.scrollHeight,
    behavior: reduced ? "auto" : "smooth",
  });
}
